import { BoardNodeHandles } from "./board-node-handles";
import { NodeResizer, type NodeProps } from "@xyflow/react";
import { useCanvasEditability, useCanvasEditSession, useCanvasResizeSession } from "../../lib/canvas-editability";
import { patchNodeData } from "../../lib/canvas-commands";
import type { StickyNoteNodeData } from "../../types/board";

import { STICKY_COLORS } from "../../lib/node-formatting";

export function StickyNoteNode({ id, data, selected, isConnectable }: NodeProps) {
  const nodeData = data as unknown as StickyNoteNodeData;
  const { canEditDocument } = useCanvasEditability();
  const edit = useCanvasEditSession("text");
  const resize = useCanvasResizeSession();
  const updateText = (text: string) => {
    if (text !== (nodeData.text ?? "")) edit.update(patchNodeData(id, { text }));
  };
  const colors = STICKY_COLORS[nodeData.color] || STICKY_COLORS.yellow;

  return (
    <>
      <NodeResizer
        {...resize}
        isVisible={!!selected && canEditDocument}
        minWidth={100}
        minHeight={60}
        lineClassName="!border-primary"
        handleClassName="!h-2.5 !w-2.5 !rounded-sm !border-2 !border-primary !bg-background"
      />
      <BoardNodeHandles type="stickyNote" isConnectable={isConnectable} />
      <div
        className="h-full w-full rounded border-l-4 p-3 shadow-md"
        style={{
          backgroundColor: colors.bg,
          borderLeftColor: colors.border,
          color: "#1a1a1a",
          fontSize: nodeData.fontSize || 14,
        }}
        onDoubleClick={edit.begin}
      >
        {edit.active ? (
          <textarea
            autoFocus
            className="nodrag nowheel h-full w-full resize-none bg-transparent outline-none"
            style={{ fontSize: nodeData.fontSize || 14 }}
            defaultValue={nodeData.text}
            onBlur={(e) => {
              updateText(e.target.value);
              edit.finish();
            }}
          />
        ) : (
          <span className="whitespace-pre-wrap">{nodeData.text || "Note..."}</span>
        )}
      </div>
    </>
  );
}
